import { Input, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { channelStatePropertyMap, NotificationChannel, notificationChannels, NotificationChannelState } from '../../../models/Notification';
import { INotificationTemplate } from '../../../models/NotificationTemplate';

@Component({
    selector: 'app-notification-template-view',
    templateUrl: './notification-template-view.component.html'
})
export class NotificationTemplateViewComponent implements OnInit {
    @Input() data: INotificationTemplate;

    channels: { name: NotificationChannel, required: boolean }[] = [];
    error: string;

    ngOnInit() {
        if (!this.data) return;

        notificationChannels.forEach(t => {
            const state = this.data[channelStatePropertyMap[t]];

            if (state >= NotificationChannelState.Available) {
                this.channels.push({
                    name: t,
                    required: state == NotificationChannelState.Required
                });
            }
        });
    }
}
